module.exports = __webpack_public_path__ + "static/media/search.cccf48d4.png";